// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"175":"ca4d7437","233":"94780730","369":"81822d44","936":"f2c8a5e0"}[chunkId] + ".css";
};